import React from "react";
import { Link } from "react-router-dom";
import styles from "./CustomLink.module.css";

export default function CustomLink({
	children,
	className = "",
	disabled = false,
	external = false,
	id = "",
	openInNewTab = false,
	state = null,
	to,
	underlined = false,
}) {
	if (disabled) {
		return children;
	}
	return !external ? (
		<Link
			className={`${(!underlined && styles.customLink) || ""} ${className}`}
			id={id}
			rel={(openInNewTab && "noopener noreferrer") || "next"}
			state={state}
			target={(openInNewTab && "_blank") || "_self"}
			to={to}
		>
			{children}
		</Link>
	) : (
		<a
			className={`${styles.customLink} ${className}`}
			href={to}
			id={id}
			rel={(openInNewTab && "noopener noreferrer") || "next"}
			target={(openInNewTab && "_blank") || "_self"}
		>
			{children}
		</a>
	);
}
